import { Component } from 'react';
import styled from 'styled-components';
import Modal from './modal';

/**
 * TODO: render GenericModal with correct settings.
 */
class BlankModal extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <StyledModal
        show={this.props.show}
        onClose={this.props.onClose}
        onSave={this.props.onClose}
        dontShowSaveButton
        dontShowHeader
        dontShowCancelButton
        modalStyle={this.props.modalStyle}
      >
        {this.props.children}
      </StyledModal>
    );
  }
}

const StyledModal = styled(Modal)`
  .my-modal-body {
    padding: 0;
  }

  .my-modal-footer {
    display: none;
  }

  ${(props) => (props.modalStyle ? props.modalStyle : '')}
`;

export default BlankModal;
